<template>
    <div id="check-password" class="check-password d-none">
        <div
            v-for="value in checkPasswordTypes"
            :key="value.id"
            class="check-password-wrapper"
            :data-type="value.type"
        >
            <span class="check-password-type">{{ value.action }}</span>
        </div>
    </div>
</template>

<script>
import inputValidation from "./../../validationInputs.js";

//Set Use Strict
("use strict");

export default {
    name: "ConfirmPasswordContainer",
    data: () => {
        return {
            checkPasswordTypes: [],
        };
    },
    created() {
        //Set Confirm Passwords Patterns
        this.checkPasswordTypes = inputValidation.confirmPasswordPatterns();
    },
};
</script>
